﻿import {ViewLockService} from '../core/services/viewLockService/viewLock.service';

export class AccountFrameController {
    public $state: angular.ui.IStateService;
    public isViewLocked: boolean = false;
    private viewLockStartTime: Date;
    public minimumViewLockDuration: number = 200;

    static $inject = ['$state', '$timeout', '$rootScope', 'viewLockService'];

    constructor($state: angular.ui.IStateService,
        private $timeout: ng.ITimeoutService,
        private $rootScope: ng.IRootScopeService,
        private viewLockService: ViewLockService
    ) {
        this.$state = $state;
        this.activate();
    }

    public activate() {
        this.$rootScope.$on('$stateChangeStart', this.stateChangeStartEventHandler);
        this.viewLockService.listen(this.viewLockServiceEventHandler);
    }

    public stateChangeStartEventHandler = (event, toState, toParams, fromState, fromParams, options) => {
        this.viewLockService.broadcast(1);
    }

    public viewLockServiceEventHandler = (event: any, args: any) => {

        if (typeof args.isViewLocked != "undefined") {

            this.lockView(args.isViewLocked);
        }
    }

    private lockView(isViewLocked: number) {

        if (isViewLocked === 0) {


            if (typeof (this.viewLockStartTime) != "undefined") {
                const lockDuration = new Date().getTime() - this.viewLockStartTime.getTime();

                if (lockDuration > this.minimumViewLockDuration) {
                    this.isViewLocked = false;
                } else {
                    this.$timeout(() => { this.isViewLocked = false; }, this.minimumViewLockDuration - lockDuration);
                }

            } else {

                //view was never locked but "unlock" was called anyway
                this.isViewLocked = false;
            }

        }

        if (isViewLocked === 1) {

            this.isViewLocked = true;
            this.viewLockStartTime = new Date();
        }

    }
}